/**
 * Unmatched ) in Javascript regular expression error occurs when some of your string contains ')'.
 * You need to escape this. Here is the function to do that:
 */

export const escapeRegExp = (str) => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
